import { useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";

export function useDashboardNav() {
  const navigate = useNavigate();
  const isAdmin = useSelector((s) => s.auth.isAdmin);

  return useCallback(
    (page = "overview") => {
      const base = isAdmin ? "/admin_dashboard" : "/mdt_dashboard";
      navigate(`${base}/${page}`);
    },
    [navigate, isAdmin]
  );
}
